<template>
    <div>
    <v-layout row wrap>
        <!-- <v-flex xs12 md1>
            <span>{{FlightInfo.AirV + ' ' + FlightInfo.FltNum}}</span>
        </v-flex> -->
        <v-flex xs12 md5>
            <div>
                <span>{{ getDateText(FlightInfo.StartDt) + " "}} </span>
                <span class="primary--text">{{FlightInfo.StartAirp + " "}}</span>
                <span>{{getTimeText(FlightInfo.StartTm)}}</span>
            </div>
        </v-flex>
        <v-flex xs12 md5>
                <span>{{" " + getDateText(FlightInfo.EndDt) + " "}} </span>
                <span class="primary--text">{{FlightInfo.EndAirp + " "}}</span>
                <span>{{getTimeText(FlightInfo.EndTm)}}</span> 
        </v-flex>
        <v-flex xs4 md2 class="text-xs-left">
            <span>{{getFlightDuration(FlightInfo.FltTm)}}</span>
        </v-flex>      
        <v-spacer></v-spacer>                               
    </v-layout>     
    <v-layout row v-if="FlightInfo.Conx=='Y'">
        <v-flex md10 class="primary--text" text-md-right style="font-size:12px;">
            Connecting flight at {{FlightInfo.EndAirp}} for {{ConnectingFlightInfo!=null?getWaitingTime(FlightInfo.EndDt, FlightInfo.EndTm,ConnectingFlightInfo.StartDt,ConnectingFlightInfo.StartTm):''}} hrs
        </v-flex>
    </v-layout>  
    </div>               
</template>

<script>
import axios from 'axios'
import helper from '../helper'
export default {
    props:[
        'FlightInfo',
        'FlightDirection',
        'ConnectingFlightInfo',
        'DepartureTimeFilter',
    ],
    computed:{
        departureTimeFilter(){
            return this.DepartureTimeFilter==null? ['00:00','23:59']:this.DepartureTimeFilter;
        }
    },
    data(){
        return {
            airlineLogo:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAA8CAMAAACac46aAAAA/FBMVEX///8lSqVcd7ySpdIzVavJ0ulpg8HW3e60kULk6PR3jsetu927xuNObLbx9Pm5mE7uKjLtHCSEmcygsNhAYbDwR03HrXHyVVvLs31peaPDr4N2e4v2jpL94+RSaqT81Nb+8fH3nJ/dwZ+ei2DYSC/7xsjksptXcLC+qHfujojjcmKAksHCpmXcs5HGnmSNlKjvnJXDuKHzY2jtgHrro5fPrHu5oWzoeW6wnXLmjn70cXb1f4RkcpjOnm6Nnsbgq4+fp7q9n1qRiXnna2C1rZuVhmd6eXnvOD/cTzuQf1vCdDtFXp6rjUh2halAV5KiiE7UTzHMglLlTkX4qq3e9GWHAAACr0lEQVR4Xu3XxZLrMBAFUF0xGCEZZHjMzMwM//8vz12eTFKTxVvEsRYzd+MueXHSapVjs//nPIgFp7FgHgsWZw7mZw6WkVyHSHCIBftIcCYjwQGR4AZwkRqGijLhSLBHHDgBJRvcdRKU4QecIg6sOzeNcbAo3yO5uB3J5asxzhU1PB7QNVP3an5/OFdJTJI+sFcGcwOm7rq9UQx+rAC9bvO7ZQs4t3y3mrovVq19WRCs0pANts/y1Wtr90clwQpAtVTXTN131uYXWncCQywTTifuxUvWji8XrTvq4BrNHGDq4yLzfW302jWbX18pKSsdrOZhc7IJHD01fDO341tFOQsD0pyWe4MdumxYu3+nPM5mBwsJ6ZYFh85ds/m9opxkq4OZkRAVgBoSaUZVAsFh6AdxKNQLwAKU7Tx/SOK04YxgxsEhiZANTZyqFN5Dk59KtwDMQXlkH5M42nzStv2U3JRgJ6GhBRS4QA1PFaA4GDQHNFsUfmafE7vTirt7R4w5L4mgewFV1cGiq7RsOAw4h0ZYFH5j37bu7mTNSIBgQAZHdUJw3VWiAgdQczjoRZ/TB/moLLZmviU44IJSio59e3HKZMo55ZHQJTPKMKOYMoue6oMxTXa61NCA56KU7vFrzhH8voWPTgAPoQABMT+VtOdX6Q/24wzMkSjAw58CaqGynv+ctu2ncq8DghdAlQCOJyIkiUiYEcGJIGrhlDBKqL5kAeDzl3Jl9uNJAgp0Q6OSNQQtplAcDeD7fPH5+u1wMuRMQLq6g2UIkJDQ8BUEwRLcsd4igLX8sNiZjFgz1cGcCgAc4hhO0l5fS5zHj5+/Cuo584CawqyhxivwBgq6gda02Cdd643ff/4yx5EmjAWghifDpMwnmYaE4wA4ZGDDh0OxCBFCwsWAT2/zec7zDyFMJNq3uzLeAAAAAElFTkSuQmCC",
            airportOfOrigin:"BKK",
            departureTime:"06:10",
            flightDuration:"01:20",
            flightType:"RT",
            airportOfDestination:"CNX",
            arrivalTime:"07:30",
            connectingFlightInfo:"",
            helper:helper,
        }
    },
    methods:{
        decodeFlightDuration(duration){
            var d = duration.split(':');
            return parseInt(d[0]) + " ชม." + parseInt(d[1]) + " นาที";
        },
        decodeTripType(typeCode){
            return typeCode=="OW"? "เที่ยวเดียว":"ไปกลับ"
        },
        getDateValue(dateNum, timeNum){
            var y = dateNum.substring(0,4);
            var m = parseInt(dateNum.substring(4,6))-1;
            var d = dateNum.substring(6,8);

            var tTime = "";
            if (timeNum.length<4) {
                tTime = "0000" + timeNum;
                tTime = tTime.substring(tTime.length-4,tTime.length);
            }else {
                tTime = timeNum; 
            }
            var h = parseInt(tTime.substring(0,2));
            var mi = parseInt(tTime.substring(2,4));            
            var tDate = new Date(y,m,d,h,mi);
            return tDate;
        },
        getDateText(dateNum){
            var y = dateNum.substring(0,4);
            var m = parseInt(dateNum.substring(4,6))-1;
            var d = dateNum.substring(6,8);
            var tDate = new Date(y,m,d).toString();
            var tDateParts = tDate.substring(0,tDate.indexOf('00:')).split(' ');
            return tDateParts[0] + ", " + tDateParts[2] + " " + tDateParts[1] + " " + tDateParts[3].substring(2,4);
        },
        getTimeText(timeNum){
            return this.helper.dateAndTime.getFourDigitTimeWithColon(timeNum);
        },
        getFlightDuration(minutes){
            var tMinutes = parseInt(minutes);
            var m = tMinutes%60;
            var h = (tMinutes - m)/60;
            var duration = h + ":" + m + " hrs";
            return duration;
        },
        getConnectingFlightInfo(){
            axios.get('api/Flight2C_1/GetConnectingFlightInfo').then(
                result=>{
                    this.connectingFlightInfo=result.data;
                }
            ).catch((error) => {
              throw error
            });             
        },
        getWaitingTime(endDateNum,endTimeNum,nextStartDateNum,nextStartTimeNum){
            var date1 = this.getDateValue(endDateNum,endTimeNum);
            var date2 = this.getDateValue(nextStartDateNum,nextStartTimeNum);
            var diffTime = Math.abs(date2.getTime()-date1.getTime())/(1000*60);
            var m = diffTime%60
            
            var h = (diffTime - m)/60;
            
            return h + ":" + m;
        }
    }
}
</script>

<style>
.airline-logo{
    width:64px;
    height: 30px;
}
.container1{
    padding-top:10px;
    padding-bottom: 10px;
}
</style>
